import { makeStyles, IconButton, Hidden } from '@material-ui/core';
import { template } from 'lodash';
import moment from 'moment';
import React, { useRef } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Item from './Item';
import { PAGING_BUTTON_ACTION_MAP } from '../../../preorder/containers/PreOrderPage/components/List/Slider';

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3, 0),
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
    textAlign: 'left',
  },
  title: {
    color: theme.palette.preOrder.main,
    fontWeight: 'bold',
    fontSize: 16,
  },
  description: {
    fontSize: 12,
  },
  navigatorContainer: {
    flexShrink: 0,
    marginLeft: theme.spacing(1),
  },
  moreSelection: {
    background: 'transparent',
    border: 0,
    fontSize: 12,
    fontWeight: 'bold',
    outline: 0,
    padding: 0,
    textDecoration: 'underline',
  },
  itemsContainer: {
    display: 'flex',
    marginTop: theme.spacing(2),
    overflowX: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },

    '& > *': {
      padding: theme.spacing(0, 1),
      flexBasis: '40%',
      flexShrink: 0,

      [theme.breakpoints.up('sm')]: {
        flexBasis: '22%',
      },

      [theme.breakpoints.up('md')]: {
        flexBasis: '18%',
      },
    },
  },
}));

const PERIOD = {
  TODAY_BEFORE_930: 'TODAY_BEFORE_930',
  TODAY_AFTER_930: 'TODAY_AFTER_930',
  NEXT_OPEN_DAY: 'NEXT_OPEN_DAY',
};

const TITLE_MAP = {
  [PERIOD.TODAY_BEFORE_930]: '午餐訂便當！現在訂 今天中午到',
  [PERIOD.TODAY_AFTER_930]: '午餐訂便當！現在訂 明天中午到',
  [PERIOD.NEXT_OPEN_DAY]: '午餐訂便當！現在訂 <%= date %>中午到',
};

const DESCRIPTION_MAP = {
  [PERIOD.TODAY_BEFORE_930]: '每日9:30前完成預訂，中午送達機台。不限便當，飲料、甜點通通可預訂！',
  [PERIOD.TODAY_AFTER_930]: '現在完成預訂，明天中午送達機台。不限便當，飲料、甜點通通可預訂！',
  [PERIOD.NEXT_OPEN_DAY]: '現在完成預訂，當天中午送達機台。不限便當，飲料、甜點通通可預訂！',
};

export default ({
  dateString,
  onProductClick,
  onMoreButtonClick,
  products,
}) => {
  const classes = useStyle();
  const containerRef = useRef(undefined);
  const theMoment = moment(dateString).utcOffset(8);
  const currentMoment = moment().utcOffset(8);
  const tomorrowMoment = currentMoment.clone().add(1, 'day').startOf('day');
  const moment930 = currentMoment.clone().set({ h: 9, m: 30 });
  const period = (() => {
    // 九點半以後，但顯示的日期不是明天
    if (
      currentMoment.isAfter(moment930)
      && tomorrowMoment.format('YYYYMMDD') !== dateString
    ) {
      return PERIOD.NEXT_OPEN_DAY;
    }
    // 九點半以後且下個營業日是明天
    if (
      currentMoment.isAfter(moment930)
      && tomorrowMoment.format('YYYYMMDD') === dateString
    ) return PERIOD.TODAY_AFTER_930;

    return PERIOD.TODAY_BEFORE_930;
  })();

  const title = template(TITLE_MAP[period])({
    date: theMoment.format('MM/DD'),
  });
  const description = DESCRIPTION_MAP[period];

  const pagingButtonClick = (type) => {
    const { scrollLeft, offsetWidth } = containerRef.current;

    containerRef.current.scrollTo({
      behavior: 'smooth',
      left: type === PAGING_BUTTON_ACTION_MAP.BACK
        ? scrollLeft - offsetWidth
        : scrollLeft + offsetWidth,
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div>
          <div className={classes.title}>{title || ''}</div>
          <div className={classes.description}>{description || ''}</div>
        </div>
        <Hidden xsDown>
          <div className={classes.navigatorContainer}>
            <IconButton
              style={{ backgroundColor: '#f5f5f5', width: 24, height: 24 }}
              onClick={() => pagingButtonClick(PAGING_BUTTON_ACTION_MAP.BACK)}
            >
              <ArrowBackIcon style={{ fontSize: 16 }} />
            </IconButton>
            <IconButton
              style={{
                marginLeft: 16,
                backgroundColor: '#f5f5f5',
                width: 24,
                height: 24,
              }}
              onClick={() => pagingButtonClick(PAGING_BUTTON_ACTION_MAP.FORWARD)}
            >
              <ArrowForwardIcon style={{ fontSize: 16 }} />
            </IconButton>
          </div>
        </Hidden>
      </div>
      <div className={classes.itemsContainer} ref={containerRef}>
        {(products || []).map((product, index) => {
          const { id } = product;

          return <Item key={id} index={index} data={product} onClick={onProductClick} />;
        })}
      </div>
      <div className="fz-text-center fz-mt-2">
        <button type="button" onClick={onMoreButtonClick} className={classes.moreSelection}>更多午餐選擇</button>
      </div>
    </div>
  );
};
